import React, { useState, useEffect } from "react";  // Make sure to include useEffect
import {RadioButtonInput } from '../../components/FormInitiators';
import DynamicTable2 from "../../components/DynamicTable2";


const pensionForm4 = ({ formData, setFormData, onFormDataChange, onBack, onNext }) => {
  

  const handleInputChange = ({ target: { name, value } }) => {
    onFormDataChange({ [name]: value });
  };

  const onTableDataChange = (key) => (rows) => {
    setFormData((prevState) => {
      return { ...prevState, [key]: rows };
    });
  };

  return (
  <div className="google_forms">
      <div className="forms">
    <form className="seventh-pay-arrears-form">
    <h3>Office Details</h3>

        <label>
        Name of the Institution:
        <input type="text" name="institutionName" value={formData.institutionName} onChange={handleInputChange} />
        </label>
        <label>
          Date of establishment of the Institution:
          <input type="date" name="establishmentDate" value={formData.establishmentDate} onChange={handleInputChange} />
        </label>

        <label>
          Date from which the Institution is 100% aided:
          <input type="date" name="aidedDate" value={formData.aidedDate} onChange={handleInputChange} />
        </label>

        <label>
        Name of the Management:
        <input type="text" name="managementName" value={formData.managementName} onChange={handleInputChange} />
        </label>

        <label>
        Name of the Region:
        <input type="text" name="region" value={formData.region} onChange={handleInputChange} />
        </label>

        
        <label>
        Place of the Regional Office:
        <input type="text" name="city" value={formData.city} onChange={handleInputChange} />
        </label>


        <label>
        Treasury:
        <input type="text" name="treasury" value={formData.treasury} onChange={handleInputChange} />
        </label>

        <label>
        District of Education Officer:
        <input type="text" name="educationOfficer" value={formData.educationOfficer} onChange={handleInputChange} />
        </label>

        <label>
        DDO code:
        <input type="text" name="ddoCode" value={formData.ddoCode} onChange={handleInputChange} />
        </label>

        <label>
        DDO retired from:
        <input type="text" name="ddoretired" value={formData.ddoretired} onChange={handleInputChange} />
        </label>

        <label>
        TO for DCRG:
        <input type="text" name="todcrg" value={formData.todcrg} onChange={handleInputChange} />
        </label>

      {/* Navigation Buttons */}
      <div className="seventh-pay-arrears-buttons-container">
        <button type="button" onClick={onBack}>Back</button>
        <button type="button" onClick={onNext}>
         Next
        </button>
      </div>
    </form>
    </div>
    </div>
  );
};

export default pensionForm4;
